import React, { FC, memo } from 'react';

import AdminSingleFieldTab from './AdminSingleFieldTab';

const Actions: FC = () => (
  <AdminSingleFieldTab
    fieldName="actions_taken"
    commentFieldName="comment_actions_taken"
    noteId="expert-note-actions"
    titleKey="tab_actions"
    hintKey="tab_actions_hint"
  />
);

export default memo(Actions);
